import { useGlobalSearchParams } from 'expo-router'

// This function replaces the 'classes' part of a path with 'folders'.
export default (extra: string = '') => {
  const { folderId, chatId, userId } = useGlobalSearchParams<{
    folderId: string
    chatId: string
    userId?: string // Editting a reply
  }>()

  return {
    pathname: `/folders/${folderId}/chats/${chatId}${extra}`,
    params: {
      userId,
    },
  }
}
